// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, event, zoomRatio) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  if (this.xPercent) {
    this.xPercent = event.clientX - container.left;
    this.yPercent = event.clientY - container.top;
  }
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function moveWithTouch(image, event, zoomRatio) {
  // calculate touch position
  event.preventDefault();
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const touch = event.touches[0];

  if (!this.xPercent) {
    this.xPercent = touch.clientX - container.left;
    this.yPercent = touch.clientY - container.top;
  }

  const currentXPosition = touch.clientX;
  const currentYPosition = touch.clientY;

  if (this.prevXPosition === null || this.prevYPosition === null) {
    this.prevXPosition = currentXPosition;
    this.prevYPosition = currentYPosition;
    return;
  }

  const deltaX = (this.prevXPosition - currentXPosition) * 1;
  const deltaY = (this.prevYPosition - currentYPosition) * 1;

  this.xPercent = (this.xPercent + deltaX);
  this.yPercent = (this.yPercent + deltaY);

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent / (image.clientWidth / 100)}% ${yPercent / ((image.clientWidth * ratio) / 100)}%`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;

  // Update previous positions
  this.prevXPosition = currentXPosition;
  this.prevYPosition = currentYPosition;
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);
  overlay.onclick = () => this.removeOverlay(overlay);
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => this.removeOverlay(overlay);

  // Add touch event listeners for mobile devices
  overlay.ontouchstart = () => {
    this.prevXPosition = null;
    this.prevYPosition = null;
  };
  overlay.ontouchmove = (event) => moveWithTouch(image, event, zoomRatio);
  // overlay.ontouchend = () => { this.xPercent = null; this.yPercent = null; };
}
function removeOverlay(overlay) {
  this.mediaGallery && this.mediaGallery.classList.remove('zoom-magnified');
  overlay.remove();
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    image.onclick = (event) => {
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    };
  });
  const zoomedImages = document.querySelectorAll('.image-magnify-gallery');
  this.mediaGallery = document.querySelector('[id^="MediaGallery-ProductGallery"]');
  zoomedImages.forEach((image) => {
    image.onclick = (event) => {
      if (this.mediaGallery && this.mediaGallery.classList.contains('zoomed-in-modal')) {
        this.mediaGallery.classList.add('zoom-magnified')
        magnify(image, zoomRatio);
        moveWithHover(image, event, zoomRatio);
      }
    };
  });
}

subscribe(PUB_SUB_EVENTS.siteLoaded, () => {
  enableZoomOnHover(2);
});
enableZoomOnHover(2);
